import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useFieldArray } from 'react-hook-form';
import { numberFormatterLocale, onCheckRequireInRow, parseFloatCheckValue } from '../fnTickit';
import { useMemo, useState } from 'react';
import DialogRemark from '../components/DialogRemark';
import { BtnRemark } from 'components/Button/ButtonAll';
import NumberInput from '../components/NumberInput';
import InputNumberItem from 'components/Input/InputNumber';


const TableReceive = ({ form, isEdit,nMuseumID }) => {

    const { control, setValue, watch, clearErrors, reset } = form;

    const { fields } = useFieldArray({
        control,
        name: "lstTicket"
    });
    const [isOpenRemark, setIsOpenRemark] = useState(false)
    const [rowClick, setRowClick] = useState(null)
    const [indexClick, setIndexClick] = useState(0)

    const watchFieldArray = watch("lstTicket");

    const isKhonKaen = useMemo(()=>{
        return nMuseumID === 1;
    },[nMuseumID])

    const controlledFields = useMemo(()=>{
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    },[fields, watchFieldArray])

    const handleOnchange = (rowData, eValue, index, sInput) => {
        if (eValue === "") {
            eValue = null;
        }
        switch (sInput) {
            case "sStartBook":
                setValue(`lstTicket.${index}.sStartBook`, eValue);
                if(!eValue){
                    setValue(`lstTicket.${index}.sEndBook`, null);
                }
                break;
            case "sEndBook":
                setValue(`lstTicket.${index}.sEndBook`, eValue);
                break;
            case "sStartTicketNo":
                setValue(`lstTicket.${index}.sStartTicketNo`, eValue);
                break;
            case "nTicketPerBook":
                setValue(`lstTicket.${index}.nTicketPerBook`, eValue);
                break;
            case "sCost":
                setValue(`lstTicket.${index}.sCost`, eValue ?? "");
                break;
        }

        //Value real time
        let nStartBook = parseFloatCheckValue(watchFieldArray[index].sStartBook);
        let nEndBook = parseFloatCheckValue(watchFieldArray[index].sEndBook);
        let nStartTicket = parseFloatCheckValue(watchFieldArray[index].sStartTicketNo);
        let nTicketPerBook = parseFloatCheckValue(watchFieldArray[index].nTicketPerBook);
        let nCost = parseFloatCheckValue(watchFieldArray[index].sCost);
        let isTicketTypeInKhonKaen = isKhonKaen && [1, 2, 15, 16].includes(rowData.nTicketTypeID)  
      
        if (!nStartBook && !nEndBook && !nStartTicket  && !nCost && isTicketTypeInKhonKaen) {
            watchFieldArray[index].sEndTicketNo = "";
            watchFieldArray[index].nTotalBook = null;
            watchFieldArray[index].nTotalTicket = null;
            watchFieldArray[index].sAmount = "";
            watchFieldArray[index].isRequire = false;
            setValue(`lstTicket.${index}.isRequire`, false);
            reset({
                ...watch(),
            });
            return;
        }

        // if (!nStartTicket) {            
        //     watchFieldArray[index].sEndTicketNo = "";
        //     watchFieldArray[index].nTotalTicket = null;
        //     watchFieldArray[index].sAmount = "";
        //     reset({
        //         ...watch(),
        //     });
        //     return;
        // }

        //cal
        let calTotalBook = parseFloatCheckValue(nStartBook) && parseFloatCheckValue(nEndBook) ? (nEndBook - nStartBook) + 1 : null;
        let calEndTicket = calTotalBook !== null ? (calTotalBook * nTicketPerBook) + nStartTicket - 1 : null;
        let calTotalTicket = calTotalBook !== null ? parseFloatCheckValue(calTotalBook * nTicketPerBook) : null;
        let calAmount = calTotalBook !== null ? parseFloatCheckValue(calTotalBook * nCost) : null;
        
        let maxLength = (watchFieldArray[index].sStartTicketNo + "").length
        let nEndTicket = (parseFloatCheckValue(calEndTicket)+"").padStart(maxLength, '0');

        //set value in list
        watchFieldArray[index].sEndTicketNo = nTicketPerBook && calEndTicket && calTotalBook > 0 ? nEndTicket : "";
        watchFieldArray[index].nTotalBook = parseFloatCheckValue(calTotalBook);
        watchFieldArray[index].nTotalTicket = calTotalTicket !== 0 ? calTotalTicket : null;
        watchFieldArray[index].sAmount = calAmount != null ? calAmount + "" : "";

        // ถ้าเป็นของขอนแก่นจะมีเงื่อนไข พิเศษเพิ่มมา
        if (isTicketTypeInKhonKaen) {
            watchFieldArray[index].sEndTicketNo = "100";
            //ลบ 1 เล่มเพราะ เล่มเริ่มต้นอาจจะไม่ใช่้ 1 เลยต้องคำนวณส่วนนัเนเพิ่มเข้าไป
            calTotalTicket = calTotalBook !== null ? (100 - nStartTicket + 1) + parseFloatCheckValue((calTotalBook - 1) * nTicketPerBook) : null;
            watchFieldArray[index].nTotalTicket = calTotalTicket !== 0 ? calTotalTicket : null;
        }

        let isCheckRequire = onCheckRequireInRow(watchFieldArray[index]);
        let isRequireValueFirst = isCheckRequire || eValue;
        
        watchFieldArray[index].isRequire = isRequireValueFirst;
        setValue(`lstTicket.${index}.isRequire`, isRequireValueFirst);
        reset({
            ...watch(),
        });
    }
    // Reset State Require in ow
    const handleOnblur = (rowData, index) => {
        let isCheckRequire = onCheckRequireInRow(rowData);

        if (!isCheckRequire) {
            watchFieldArray[index].isRequire = isCheckRequire;
            setValue(`lstTicket.${index}.isRequire`, isCheckRequire);
            clearErrors(`lstTicket.${index}`)
        }
    }

    const handleOnblurPadStart = (eValue,rowData,index) => {
        let maxLength = (rowData.sStartBook + "").length
        let padEndBook = eValue.padStart(maxLength, '0');
        if(parseInt(padEndBook) !== 0)
        {
            setValue(`lstTicket.${index}.sEndBook`, padEndBook);
            reset({
                ...watch(),
            });
        }
        
    }

    return (
        <>
            <TableContainer id='table-receive' component={Paper}>
                <Table sx={{ minWidth: 1400 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '40px', width: '40px' }}>ที่</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '200px', width: '200px' }}>ประเภทบัตรเข้าชมพิพิธภัณฑ์</TableCell>
                            <TableCell component="th" padding='none' colSpan={2}>เล่มที่</TableCell>
                            <TableCell component="th" padding='none' colSpan={2}>เลขที่</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>จำนวน<br />เล่ม</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '100px', width: '100px' }}>จำนวน<br />ใบต่อเล่ม</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>จำนวน<br />ใบที่รับ</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '100px', width: '100px' }}>ราคาต้นทุน<br />ต่อเล่ม</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '100px', width: '100px' }}>จำนวนเงิน</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>หมายเหตุ</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>เริ่มต้น<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>สิ้นสุด<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>เริ่มต้น<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>สิ้นสุด<span className='red'>*</span></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            controlledFields.map((row, index) => {
                                const fieldName = `lstTicket.${index}`;
                                const RowRequire = row.isRequire;
                                let isTicketTypeInKhonKaen = isKhonKaen && [1, 2, 15, 16].includes(row.nTicketTypeID)
                              
                                return (
                                    <TableRow key={`${fieldName}.sID`}>
                                        <TableCell align="center" >{index + 1}</TableCell>
                                        <TableCell align="left">{row.sTypeTicket}</TableCell>
                                        <TableCell align="right">
                                            <NumberInput
                                                id={`${fieldName}.sStartBook`}
                                                name={`${fieldName}.sStartBook`}
                                                defaultValue={row.sStartBook}
                                                required={RowRequire}
                                                IsCanMinus={false}
                                                IsShowMessageError={false}
                                                min={1}
                                                IsComma={false}
                                                IsShowTextCont={false}
                                                disabled={isEdit}
                                                onChange={(e) => handleOnchange(row, e, index, "sStartBook")}
                                                onBlur={() => handleOnblur(row, index)}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <NumberInput
                                                id={`${fieldName}.sEndBook`}
                                                name={`${fieldName}.sEndBook`}
                                                defaultValue={row.sEndBook}
                                                required={RowRequire}
                                                IsCanMinus={false}
                                                min={parseFloat(row.sStartBook)}
                                                // maxLength={row.sStartBook == null || (row.sEndBook >= row.sStartBook) ? undefined : (row.sStartBook+"").length}
                                                IsShowMessageError={false}
                                                IsComma={false}
                                                IsShowTextCont={false}
                                                disabled={isEdit || row.sStartBook == null}
                                                onChange={(e) => handleOnchange(row, e, index, "sEndBook")}
                                                onBlur={(e) => {
                                                    handleOnblurPadStart(e,row,index);
                                                    handleOnblur(row, index);
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <NumberInput
                                                id={`${fieldName}.sStartTicketNo`}
                                                name={`${fieldName}.sStartTicketNo`}
                                                defaultValue={row.sStartTicketNo}
                                                required={RowRequire}
                                                IsCanMinus={false}
                                                // min={1}
                                                maxLength={isTicketTypeInKhonKaen ? 3 : undefined}
                                                max={isTicketTypeInKhonKaen ? 100 : undefined}
                                                IsComma={false}
                                                IsShowMessageError={false}
                                                IsShowTextCont={false}
                                                disabled={isEdit}
                                                onChange={(e) => handleOnchange(row, e, index, "sStartTicketNo")}
                                                onBlur={() => handleOnblur(row, index)}
                                            />
                                        </TableCell>
                                        <TableCell align="right">{row.sEndTicketNo}</TableCell>
                                        <TableCell align="right">{numberFormatterLocale(row.nTotalBook, 0)}</TableCell>
                                        <TableCell align="right">
                                            <InputNumberItem
                                                id={`${fieldName}.nTicketPerBook`}
                                                name={`${fieldName}.nTicketPerBook`}
                                                defaultValue={row.nTicketPerBook}
                                                required={isTicketTypeInKhonKaen ? false : RowRequire}
                                                maxDigits={0}
                                                ShowDigits={0}
                                                IsCanMinus={false}
                                                IsShowMessageError={false}
                                                disabled={isEdit || isTicketTypeInKhonKaen}
                                                onChange={(e) => handleOnchange(row, e, index, "nTicketPerBook")}
                                                onBlur={() => handleOnblur(row, index)}
                                            />
                                        </TableCell>
                                        <TableCell align="right">{numberFormatterLocale(row.nTotalTicket, 0)}</TableCell>
                                        <TableCell align="right">
                                            <InputNumberItem
                                                id={`${fieldName}.sCost`}
                                                name={`${fieldName}.sCost`}
                                                defaultValue={row.sCost}
                                                required={RowRequire}
                                                maxDigits={2}
                                                ShowDigits={2}
                                                IsCanMinus={false}
                                                min={0}
                                                IsShowMessageError={false}
                                                disabled={isEdit}
                                                onChange={(e) => handleOnchange(row, e, index, "sCost")}
                                                onBlur={() => handleOnblur(row, index)}
                                            />
                                        </TableCell>
                                        <TableCell align="right">{numberFormatterLocale(row.sAmount, 2)}</TableCell>
                                        <TableCell align="center">
                                            {
                                                ((isEdit && row.sRemark) || !isEdit)
                                                    ? <BtnRemark
                                                        id={"btn" + index}
                                                        IsCircleWithOutText
                                                        className='btnicon-remark'
                                                        onClick={() => {
                                                            setRowClick(row)
                                                            setIndexClick(index)
                                                            setIsOpenRemark(true)
                                                        }}
                                                    />
                                                    : null
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                        {
                            controlledFields.length === 0 ?
                                <TableRow >
                                    <TableCell align="center" colSpan={12}>ไม่พบข้อมูล</TableCell>
                                </TableRow>
                                :
                                null
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <DialogRemark
                isOpenRemark={isOpenRemark}
                setIsOpenRemark={setIsOpenRemark}
                row={rowClick}
                controlledFields={controlledFields}
                indexClick={indexClick}
                setValue={setValue}
                isView={isEdit}
            />
        </>
    )
}

export default TableReceive
